import React from 'react';
import { useQuery } from 'react-query';
import { ThunderboltTwoTone } from '@ant-design/icons';
import { Popover, List, Skeleton, Card } from 'antd';
import ConsequenceModal from '../../workflow/ConsequenceModal';
import ModalController from 'components/ModalController';

import {
  GetListProcTaskNotif,
  UpdateProcTaskConseqStatus,
  ViewProcTaskNotifResponse,
} from 'services/workflow';
import AntButton from '../../../components/Button';
import RouterLink from '../../../components/RouterLink';
import PopoverController from '../../../components/PopoverController';

const getUrl = (procmodule: string, id: number, target?: string) => {
  if (procmodule === 'SINVOICE') {
    return `/supplier-invoice/${id}`;
  } else if (procmodule === 'PROPOSAL') {
    return `/proposal/${id}`;
  } else if (procmodule === 'GUARANTY') {
    return `/guaranty/${id}`;
  } else if (procmodule === 'CONTRACT') {
    return `/proposal/${id}?phase=PROD`;
  } else if (procmodule === 'COLLECTION') {
    return `/collection/${id}`;
  } else if (procmodule === 'FINASSET') {
    return `/asset/${id}/PROD`;
  } else if (procmodule === 'CINVOICE') {
    return `/client-invoice/${id}`;
  } else if (procmodule === 'THIRDPARTY') {
    return `/third-party/${id}/TP`;
  } else if (procmodule === 'FVCONTEXT') {
    return `/configuration/parassetfvcontextdetail/${id}`;
  } else if (procmodule === 'ENTADDATTR') {
    return `/configuration/display/parentityadditionalattribute`;
  } else if (procmodule === 'PARLIST') {
    return `/configuration/management/parameters/${target}`;
  } else if (procmodule === 'PRATTRIB') {
    return `/configuration/management/attribute/${id}`;
  } else if (procmodule === 'CATALOG') {
    return `/configuration/asset-catalog/${id}`;
  } else if (procmodule === 'SCORING'){
    return `/scoring/${id}`;
  }
  return undefined;
};

export type NotificationsTableProps = {
  title?: string;
  height?: number;
  isFromLink?: boolean;
  notifTable?: ViewProcTaskNotifResponse[];
};

const NotificationsTable = (props: NotificationsTableProps) => {
  const { title, height, isFromLink, notifTable } = props;

  const { data, refetch, isFetching } = useQuery(
    'GetListProcTaskNotif',
    () => GetListProcTaskNotif().then((res) => res.list || []),
    {
      enabled: !isFromLink,
    }
  );

  const dataTable = notifTable ?? data;

  const actionNotif = (notifid: number, conseqstatus: string) => {
    return UpdateProcTaskConseqStatus({ conseqstatus, notifid }).then(() => {
      refetch();
    });
  };

  return (
    <Card title={title} size="small" type="inner" style={{ height: height }}>
      <List
        bordered
        pagination={{
          pageSize: 3,

          size: 'small',
        }}
        dataSource={dataTable ?? []}
        itemLayout="horizontal"
        renderItem={(item) => (
          <List.Item
            key={item.notifid}
            actions={[
              <PopoverController key={item.notifid}>
                {({ setVisible, visible }) => (
                  <Popover
                    placement="bottomRight"
                    visible={visible}
                    trigger="click"
                    onVisibleChange={setVisible}
                    content={
                      <AntButton
                        comcode="CLOSE"
                        onClick={(e) => {
                          actionNotif(item.notifid, 'CLOSE');
                          setVisible(false);
                        }}
                      />
                    }
                  >
                    <AntButton
                      comcode="action"
                      icon={<ThunderboltTwoTone twoToneColor="#eb2f96" />}
                      size="small"
                      onClick={() => setVisible(true)}
                    />
                  </Popover>
                )}
              </PopoverController>,
            ]}
          >
            <Skeleton avatar title={false} loading={isFetching} active>
              <List.Item.Meta
                title={
                  <RouterLink
                    to={getUrl(
                      item.entitytarget == null
                        ? item.procmodule
                        : item.entitytarget,
                      item.entitytarget == null
                        ? item.objectid
                        : item.subentityid
                    )}
                  >
                    {item.modulename} - {item.objectreference}
                  </RouterLink>
                }
                description={item.cmessage}
              />
              <div style={{ textAlign: 'right' }}>
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      <a onClick={() => setVisible(true)}>
                        {item.notifmessage}
                      </a>
                      <ConsequenceModal
                        entityId={item.objectid}
                        entity={item.procmodule}
                        taskid={item.taskid}
                        conseqid={item.notifid}
                        visible={visible}
                        title={item.modulename + ' - ' + item.objectreference}
                        onCancel={() => setVisible(false)}
                        onSuccess={() => setVisible(false)}
                      />
                    </>
                  )}
                </ModalController>
                <div style={{ color: 'blue' }}>{item.sendername}</div>
              </div>
            </Skeleton>
          </List.Item>
        )}
      />
    </Card>
  );
};

export default NotificationsTable;
